/**
 * The master lists the /process-config dialogs read — by-product samples, departments, test
 * types and the Configuration → Parameter master — fetched once per page.
 */
import { useEffect, useState } from "react";
import Axios from "axios";

// 2026-10-13 (owner) · a sample step samples a BY-PRODUCT only — what /process-config's Sampling
// offers. Product and raw materials were listed as a fallback and are not offered any more.
const SAMPLE_GROUPS = [["By Product", ["By Product"]]];
let samplingLists = null;
export function useSamplingLists() {
  const [lists, setLists] = useState(samplingLists);
  useEffect(() => {
    if (samplingLists) return undefined;
    let alive = true;
    const headers = { Authorization: `Bearer ${localStorage.getItem("Token")}` };
    const get = (url, params) => Axios.get(url, { params, headers }).then((r) => r.data).catch(() => null);
    Promise.all([
      get("/bp/bp_get_material_inventory", { module_type: "prod" }),
      get("/bp/departdata"),
      get("/bp/bp_get_all_testing_type"),
      get("/bp/bp_get_parameters"),
    ]).then(([inv, dep, tests, params]) => {
      const lists = {
        samples: SAMPLE_GROUPS.map(([label, types]) => ({
          label,
          options: (inv?.data || []).filter((i) => types.includes(i?.material_type))
            .map((i) => ({ value: i.material_id, label: i.material_name, unit: i.unit })),
        })).filter((g) => g.options.length),
        // Every inventory material by id, so a step that already samples a product or raw material
        // (chosen before only by-products were offered) is still shown by its name.
        allMaterials: Object.fromEntries((inv?.data || []).map((i) => [String(i.material_id),
          { label: i.material_name, unit: i.unit, type: i.material_type }])),
        departments: (dep?.departdata || []).map((d) => ({ value: d.id, label: d.department_name })),
        tests: (tests?.data || []).map((t) => ({ value: t.testing_type_id, label: t.testing_type })),
        parameters: (params?.data || []).map((p) => ({ value: p.id, label: p.parameter_name, unit: p.unit })),
      };
      // 2026-10-13 · kept for the page only when every list actually arrived. A request that
      // failed (a 401 after the session ended, a network blip) used to be cached as an empty
      // list until a full reload — the sample picker stayed blank even after signing in again.
      if (inv && dep && tests && params) samplingLists = lists;
      if (alive) setLists(lists);
    });
    return () => { alive = false; };
  }, []);
  return lists || { samples: [], allMaterials: {}, departments: [], tests: [], parameters: [] };
}
